<div>

  @if (meetDay() && (isStudentLoggedIn() || isGuest())) {
  <div class="jumbotron rounded-lg shadow">

    <h3>{{ 'Signup for event' | translate}}</h3>

    <div class="mb-3">

      <div class="row mb-2">
        <div class="col-6 font-weight-bold text-secondary">
          {{ 'Event' | translate}}:
        </div>
        <div class="col-6">
          {{ meetDay()!.name}}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6 font-weight-bold text-secondary">
          {{ 'Date' | translate}}:
        </div>
        <div class="col-6">
          {{ meetDay()!.date | date:'dd-MM-YYYY'}}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6 font-weight-bold text-secondary">
          {{ 'Address' | translate}}:
        </div>
        <div class="col-6">
          {{ meetDay()!.address!.street }} {{ meetDay()!.address!.number }}{{ meetDay()!.address!.numberSuffix ? '-' + meetDay()!.address!.numberSuffix : ''}}<br />
          {{ meetDay()!.address!.postalCode }}, {{ meetDay()!.address!.city }}<br />
          {{ locale.getCountryName(meetDay()!.address!.country) | translate }}
        </div>
      </div>

    </div>

    @if (!meetDayStudent()) {
    <div>
      @if (meetDay()!.registeredCompanies) {
      <div class="top-selected-companies">

        @if (isCompanySelectionEnabled() && !hasRounds() && !isMeetDayFull()) {
        <div class="alert alert-info">
          <p class="p-0 m-0">
            {{ 'Please provide us your top' | translate }} {{ maxCompaniesSelectable() }} {{ 'companies you want to meet' | translate }}
          </p>
        </div>
        }

        @if (isCompanySelectionEnabled() && hasRounds() && !isMeetDayFull()) {
        <div class="alert alert-info">
          <p class="p-0 m-0">
            <strong>{{ 'How it works' | translate }}:</strong> {{ 'This event uses timeslots. Select one company per timeslot - you will visit each selected company during their assigned time window.' | translate }}
          </p>
        </div>
        }

        @if (isCompanySelectionEnabled() && !isMeetDayFull()) {
        @if (hasRounds()) {
        <div class="mb-3">
          @for (round of roundOptions(); track round.id; let index = $index) {
          <div class="card">
            <h2 class="card-header">
              <button class="btn btn-link w-100 text-left p-0 text-decoration-none" (click)="togglePanel(index)">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center flex-wrap mb-1">
                      <!-- Time Badge with State Color -->
                      <span [class]="'badge mr-2 ' + getRoundBadgeClass(round.id)">
                        {{ round.roundTimeStart | date:'HH:mm' }} - {{ round.roundTimeEnd | date:'HH:mm' }}
                      </span>
                      <span class="text-muted">
                        {{ 'Meeting' | translate }} {{ index + 1 }} {{ 'of' | translate }} {{ roundOptions().length }}
                      </span>
                      @if (getRoundTotalRemainingSlots(round.id) > 0 && !getRoundSelection(round.id)) {
                      <span class="badge badge-light ml-2">
                        <i class="fas fa-users mr-1"></i>{{ getRoundTotalRemainingSlots(round.id) }} {{ 'slots left' | translate }}
                      </span>
                      }
                    </div>
                    <!-- Selected Company -->
                    @if (getRoundSelection(round.id)) {
                    <div>
                      <small class="text-success d-flex align-items-center">
                        <i class="fas fa-check-circle mr-2"></i>
                        <span>{{ getSelectedCompanyName(round.id) }}</span>
                      </small>
                    </div>
                    }
                    <!-- Skipped State -->
                    @if (!getRoundSelection(round.id) && isRoundVisited(round.id)) {
                    <div>
                      <small class="text-muted d-flex align-items-center">
                        <i class="fas fa-forward mr-2"></i>
                        <span>{{ 'Skipped' | translate }}</span>
                      </small>
                    </div>
                    }
                  </div>
                  <!-- Status Icon -->
                  <div class="ml-2">
                    @if (getRoundSelection(round.id)) {
                    <i class="fas fa-check-circle text-success" style="font-size: 1.25rem;"></i>
                    } @else if (isRoundVisited(round.id)) {
                    <i class="fas fa-forward text-muted" style="font-size: 1.25rem;"></i>
                    } @else {
                    <i class="fas fa-circle text-light" style="font-size: 1.25rem;"></i>
                    }
                  </div>
                </div>
              </button>
            </h2>
            @if (activePanel() === index) {
            <div class="card-body">
              <!-- Company Grid -->
              <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                <!-- No selection card -->
                <div class="min-w-0">
                  <div class="company-card h-full flex flex-col items-center justify-center border bg-white p-4 cursor-pointer transition-shadow hover:shadow-md" [class.border-gray-400]="!getRoundSelection(round.id) && isRoundVisited(round.id)" [class.border-mty-primary]="!getRoundSelection(round.id) && !isRoundVisited(round.id)" [style.border-style]="'dashed'" (click)="skipRound(round.id)">
                    @if (!getRoundSelection(round.id) && isRoundVisited(round.id)) {
                    <i class="fas fa-check-circle text-gray-400 mb-2 text-2xl"></i>
                    } @else {
                    <i class="fas fa-forward text-gray-400 mb-2 text-2xl"></i>
                    }
                    <span class="text-sm font-medium text-gray-700">{{ 'No selection' | translate }}</span>
                  </div>
                </div>

                @for (company of registeredCompaniesSorted(); track company.id) {
                <div class="min-w-0">
                  <div class="company-card relative h-full flex flex-col items-center border border-gray-200 bg-white p-4 overflow-hidden transition-shadow hover:shadow-md" [class.border-mty-primary]="getRoundSelection(round.id) === company.id" [class.!border-2]="getRoundSelection(round.id) === company.id" [class.bg-gray-50]="isCompanySelectedInOtherRound(company.id, round.id) || isCompanyFullForRound(company.id, round.id)" [class.cursor-not-allowed]="isCompanySelectedInOtherRound(company.id, round.id) || isCompanyFullForRound(company.id, round.id)" [class.cursor-pointer]="!isCompanySelectedInOtherRound(company.id, round.id) && !isCompanyFullForRound(company.id, round.id)" [class.opacity-60]="isCompanySelectedInOtherRound(company.id, round.id) || isCompanyFullForRound(company.id, round.id)" (click)="!isCompanySelectedInOtherRound(company.id, round.id) && !isCompanyFullForRound(company.id, round.id) && company.id && setRoundSelection(round.id, company.id)">
                    <!-- Full badge -->
                    @if (isCompanyFullForRound(company.id, round.id)) {
                    <span class="absolute top-2 right-2 rounded bg-gray-500 px-1.5 py-0.5 text-[0.65rem] font-bold uppercase text-white">
                      {{ 'Full' | translate }}
                    </span>
                    }

                    <!-- Selection indicator -->
                    @if (getRoundSelection(round.id) === company.id) {
                    <i class="fas fa-check-circle absolute top-2 right-2 text-xl text-mty-primary"></i>
                    }

                    <!-- Company avatar -->
                    <img [src]="company.avatarUri || avatarPlaceholder" [alt]="company.name" class="mb-2 h-20 w-20 rounded object-cover">

                    <!-- Company name -->
                    <span class="text-sm font-medium text-gray-800">{{ company.name }}</span>

                    <!-- Capacity indicator -->
                    @if (!isCompanyFullForRound(company.id, round.id) && getRoundSelection(round.id) !== company.id && getCompanyCapacityInfo(company.id, round.id).text) {
                    <div class="mt-auto pt-3 w-full">
                      <div class="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
                        <div class="h-full rounded-full transition-all" [class.bg-green-500]="getCompanyCapacityInfo(company.id, round.id).percentage < 50" [class.bg-yellow-500]="getCompanyCapacityInfo(company.id, round.id).percentage >= 50 && getCompanyCapacityInfo(company.id, round.id).percentage < 80" [class.bg-red-500]="getCompanyCapacityInfo(company.id, round.id).percentage >= 80" [style.width.%]="getCompanyCapacityInfo(company.id, round.id).percentage"></div>
                      </div>
                      <small class="mt-1 block text-center text-xs text-gray-500">{{ getCompanyCapacityInfo(company.id, round.id).text }}</small>
                    </div>
                    }

                    <!-- Already selected badge -->
                    @if (isCompanySelectedInOtherRound(company.id, round.id) && !isCompanyFullForRound(company.id, round.id)) {
                    <span class="absolute bottom-2 left-1/2 -translate-x-1/2 rounded bg-gray-500 px-2 py-0.5 text-xs text-white whitespace-nowrap">
                      {{ 'Already selected' | translate }}
                    </span>
                    }
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </div>
          }
        </div>
        } @else {
        @for (position of companySelectionPositions(); track position) {
        <div class="form-group">
          <label>{{ 'Number' | translate}} {{ position }}:</label>
          <select class="form-control" [ngModel]="getCompanyIdAtPosition(position)" (ngModelChange)="setCompanyAtPosition(position, $event)">
            <option [ngValue]="null">{{ 'Select a company' | translate }}</option>
            @for (company of getAvailableCompaniesForPosition(position); track company.id) {
            <option [ngValue]="company.id">
              {{ company.name }}
            </option>
            }
          </select>
        </div>
        }
        }
        }
      </div>
      }

      @if (isStudentLoggedIn() && studentProfile && !isMeetDayFull()) {
      <div class="form-group">

        @if ((studentProfile.studentProfileCvs?.length ?? 0) === 0) {
        <div class="form-group btn-toolbar justify-content-start">
          <button class="btn btn-secondary" (click)="addResume()">
            <fa-icon [icon]="faIdCard"></fa-icon>
            {{'Add your resume to stand out' | translate}}
          </button>
        </div>
        }

        <div class="custom-control custom-checkbox">
          <input class="custom-control-input" id="hasAcceptedPrivacyAndData" type="checkbox" [(ngModel)]="hasAcceptedPrivacyAndData" />
          <label class="custom-control-label" for="hasAcceptedPrivacyAndData">
            {{'I consent to the use of data and media in which I may be involved, and to the privacy terms as described in the privacy statement.' | translate}}
            <br />
            <a target="_blank" href="/pages/privacyverklaring">{{ 'Read privacy statement' | translate}}</a>
          </label>
        </div>

        <div class="custom-control custom-checkbox">
          <input class="custom-control-input" id="acceptsServiceAndMarketingMessaging" type="checkbox" [(ngModel)]="acceptsServiceAndMarketingMessaging" />
          <label class="custom-control-label" for="acceptsServiceAndMarketingMessaging">
            {{'I consent to receive updates about our services and marketing messages.' | translate}}
          </label>
        </div>

      </div>
      }

      <div>

        @if (isMeetDayFull()) {
        <div class="alert alert-warning">
          {{ 'Registration limit reached for this meetday.' | translate }}
        </div>
        }

        <!-- Options for logged-in students -->
        @if (isStudentLoggedIn() && !isMeetDayFull()) {
        <div>
          <button type="button" class="btn btn-primary btn-lg d-block w-100" (click)="signUp()" [disabled]="isSubmitting()">
            @if (isSubmitting()) {
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            }
            {{ isSubmitting() ? ('Registering...' | translate) : ('Sign me up' | translate) }}
          </button>
        </div>
        }

        <!-- Options for anonymous users -->
        @if (!isStudentLoggedIn() && !showAnonymousForm() && !isMeetDayFull()) {
        <div>
          <div class="mb-3">
            <button type="button" class="btn btn-primary btn-lg btn-block mb-2" (click)="signUp()">
              {{ 'Login to Meet the Youngsters' | translate }}
            </button>
            @if (!hasRounds()) {
            <div class="text-center">
              <small class="text-muted">{{ 'Already have an account?' | translate }}</small>
            </div>
            }
          </div>

          <!-- Anonymous signup option (hidden in rounds mode) -->
          @if (!hasRounds()) {
          <div class="text-center mb-3">
            <small class="text-muted">{{ 'or' | translate }}</small>
          </div>

          <div>
            <button type="button" class="btn btn-outline-secondary btn-block" (click)="toggleAnonymousForm()">
              {{ 'Sign up without account' | translate }}
            </button>
          </div>
          }
        </div>
        }

        <!-- Anonymous registration form (hidden in rounds mode and when full) -->
        @if (!isStudentLoggedIn() && showAnonymousForm() && !hasRounds() && !isMeetDayFull()) {
        <div>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">{{ 'Signup for event' | translate }}</h6>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleAnonymousForm()">
              {{ 'Back' | translate }}
            </button>
          </div>

          <!-- Personal details -->
          <h6 class="mb-3">{{ 'Personal details' | translate }}</h6>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'First name' | translate }} *</label>
                <input type="text" class="form-control" [value]="anonymousFormData().firstName" (input)="updateAnonymousFormField('firstName', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().firstName && showAnonymousForm()">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'Last name' | translate }} *</label>
                <input type="text" class="form-control" [value]="anonymousFormData().lastName" (input)="updateAnonymousFormField('lastName', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().lastName && showAnonymousForm()">
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">{{ 'Email address' | translate }} *</label>
            <input type="email" class="form-control" [value]="anonymousFormData().emailAddress" (input)="updateAnonymousFormField('emailAddress', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().emailAddress && showAnonymousForm()" placeholder="{{ 'Enter your email address' | translate }}">
          </div>

          <div class="form-group">
            <label class="font-weight-bold">{{ 'Phone number' | translate }} ({{ 'optional' | translate }})</label>
            <input type="tel" class="form-control" [value]="anonymousFormData().phoneNumber" (input)="updateAnonymousFormField('phoneNumber', $any($event.target).value)">
          </div>

          <!-- Address Information -->
          <h6 class="mb-3 mt-4">{{ 'Address' | translate }}</h6>
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'Street' | translate }} *</label>
                <input type="text" class="form-control" [value]="anonymousFormData().streetName" (input)="updateAnonymousFormField('streetName', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().streetName && showAnonymousForm()">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'Number' | translate }} *</label>
                <input type="text" class="form-control" [value]="anonymousFormData().houseNumber" (input)="updateAnonymousFormField('houseNumber', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().houseNumber && showAnonymousForm()">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'Postal code' | translate }} *</label>
                <input type="text" class="form-control" [value]="anonymousFormData().zipCode" (input)="updateAnonymousFormField('zipCode', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().zipCode && showAnonymousForm()">
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'City' | translate }} *</label>
                <input type="text" class="form-control" [value]="anonymousFormData().city" (input)="updateAnonymousFormField('city', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().city && showAnonymousForm()">
              </div>
            </div>
          </div>

          <!-- Education Information -->
          <h6 class="mb-3 mt-4">{{ 'Education' | translate }}</h6>
          <div class="form-group">
            <label class="font-weight-bold">{{ 'Educational institution' | translate }} *</label>
            <input type="text" class="form-control" [value]="anonymousFormData().educationalInstitution" (input)="updateAnonymousFormField('educationalInstitution', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().educationalInstitution && showAnonymousForm()" placeholder="{{ 'Enter your school or university name' | translate }}">
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'Education level' | translate }} *</label>
                <select class="form-control" [value]="anonymousFormData().educationLevel" (change)="updateAnonymousFormField('educationLevel', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().educationLevel && showAnonymousForm()">
                  <option value="">{{ 'Select education level' | translate }}</option>
                  @for (level of educationLevels; track level.id) {
                  <option [value]="level.id">{{ level.name }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="font-weight-bold">{{ 'Year' | translate }} *</label>
                <select class="form-control" [value]="anonymousFormData().academicYear" (change)="updateAnonymousFormField('academicYear', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().academicYear && showAnonymousForm()">
                  <option value="">{{ 'Select year' | translate }}</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-bold">{{ 'Education' | translate }} *</label>
            <input type="text" class="form-control" [value]="anonymousFormData().studyProgram" (input)="updateAnonymousFormField('studyProgram', $any($event.target).value)" [class.is-invalid]="!anonymousFormData().studyProgram && showAnonymousForm()" placeholder="{{ 'Enter your study program' | translate }}">
          </div>

          <!-- Consent checkboxes -->
          <h6 class="mb-3 mt-4">{{ 'Privacy & Consent' | translate }}</h6>
          <div class="custom-control custom-checkbox mb-2">
            <input class="custom-control-input" id="anonymousPrivacyAndData" type="checkbox" [checked]="anonymousHasAcceptedPrivacyAndData()" (change)="updateAnonymousConsentField('hasAcceptedPrivacyAndData', $any($event.target).checked)" />
            <label class="custom-control-label" for="anonymousPrivacyAndData">
              {{ 'I consent to the use of data and media in which I may be involved, and to the privacy terms as described in the privacy statement.' | translate }} *
              <br />
              <a target="_blank" href="/pages/privacyverklaring" class="text-primary">{{ 'Read privacy statement' | translate }}</a>
            </label>
          </div>

          <div class="custom-control custom-checkbox mb-3">
            <input class="custom-control-input" id="anonymousServiceAndMarketingMessaging" type="checkbox" [checked]="anonymousAcceptsServiceAndMarketingMessaging()" (change)="updateAnonymousConsentField('acceptsServiceAndMarketingMessaging', $any($event.target).checked)" />
            <label class="custom-control-label" for="anonymousServiceAndMarketingMessaging">
              {{ 'I consent to receive updates about our services and marketing messages.' | translate }} *
            </label>
          </div>

          <!-- Submit button -->
          <div class="text-center">
            <button type="button" class="btn btn-primary btn-lg" [disabled]="!isAnonymousFormValid() || isSubmittingAnonymous()" (click)="submitAnonymousRegistration()">
              @if (isSubmittingAnonymous()) {
              <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true">
              </span>
              }
              {{ isSubmittingAnonymous() ? ('Registering...' | translate) : ('Register for event' | translate) }}
            </button>
          </div>

        </div>
        }

      </div>

    </div>
    }

    @if (meetDayStudent()) {
    <div>
      <div class="alert alert-info">
        <p>
          {{ 'You are already signed up for this event' | translate }}
        </p>
        @if (isStudentLoggedIn()) {
        <div>
          <button class="btn btn-danger" (click)="unSubscribeStudentForMeetday()">
            {{ 'Unsubscribe me' | translate }}
          </button>
        </div>
        }
      </div>

      <!-- QR Code for attendance confirmation -->
      @if (isStudentLoggedIn() && meetDayId()) {
      <div class="mt-4 d-flex justify-content-center">
        <div style="max-width: 320px; width: 100%;">
          <app-student-meetday-qr [meetDayId]="meetDayId()!"></app-student-meetday-qr>
        </div>
      </div>
      }
    </div>
    }


    <div class="event-companies mt-3">
      <h3 class="mb-3">{{ 'Attending companies' | translate }}</h3>

      @if (meetDay()!.registeredCompanies) {
      <div>
        <div class="bg-white rounded shadow p-3">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            @for (company of meetDay()!.registeredCompanies; track company.id) {
            <div>
              <app-company-card [data]="company" [roleType]="roleType" [showMatchPercentage]="true"></app-company-card>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }

</div>
